import { CATEGORIES_METADATA } from '~/data/categories'

export const badgesMap = [
  {
    key: 'bestSeller',
    test: (hit: any) =>
      Object.values(hit.products || {}).some(
        (product: any) => product.prod_top_rated && product.enabled,
      ) || hit?.prod_top_rated,
    classes:
      'bg-teal-lightest text-teal-dark rounded-full px-2 py-1 text-sm font-semibold leading-[21px]',
    text: 'Bestseller',
  },
  {
    key: 'highPrescription',
    test: (hit: any) =>
      (
        hit.Frame___Features ||
        hit.Frame___Features_search ||
        hit.Badges_search ||
        hit.Badges ||
        []
      ).includes('supportshighprescriptions') && hit.enabled,
    classes:
      'bg-green-lightest text-green-dark rounded-full px-2 py-1 text-sm font-semibold leading-[21px]',
    text: 'High Prescription',
  },
  {
    key: 'nonRx',
    test: (hit: any) => hit.family === 'frame_nonrx' && hit.enabled,
    classes:
      'bg-oranges-lightest text-oranges-dark rounded-full px-2 py-1 text-sm font-semibold leading-[21px]',
    text: 'Non-Prescription',
  },
  {
    key: 'rxOnly',
    test: (hit: any) =>
      hit.frame_type_code === 'ZunniesSports' ||
      (hit.frame_type_code_search?.includes('ZunniesSports') && hit.enabled),
    classes:
      'bg-teal-lightest text-teal-dark rounded-full px-2 py-1 text-sm font-semibold leading-[21px]',
    text: 'Prescription Only',
  },
]

export const badgesMapWithLinks = {
  nonRx: {
    href: CATEGORIES_METADATA().find(
      (category) => category.key === 'sportsRxOnly',
    )?.href,
    description: 'Adding a prescription?',
    linkText: 'View prescription-only styles',
  },
  rxOnly: {
    href: CATEGORIES_METADATA().find(
      (category) => category.key === 'sportsNonRx',
    )?.href,
    description: 'More colors available (non-prescription only)',
    linkText: 'View non-prescription styles',
  },
}
